import apiClient from "api/client/axios.client";

export interface NoticeCategoryDto {
  LocalizedName: string;
}

export interface NoticeDetailDto {
  Id: string;
  NoticeId: string;
  Title: string;
  Unit: number;
  Vat: number;
  Count: number;
  Order: number;
  ForceSupply: number;
  AddressId: string;
  AddressVersion: number;
  Description?: string;
}

export interface NoticeHeaderDto {
  Id: string;
  CategoryId?: string;
  Title: string;
  Description?: string;
  NoticeType?: string;
  NoticeState?: string;
  Shipping?: string;
  ExpirationDays?: number;
  ForceSupply?: string;
  TotalCountView?: number;
  AlbumId?: string | null;
  CreatedDate?: string;
  TenantCompanyId?: string;
  
  // دسته‌بندی و جزئیات
  Category?: NoticeCategoryDto;
  NoticeDetails?: NoticeDetailDto[];

  // فیلدهای اختصاصی آثار هنری و نمایش
  Price?: number;
  ArtistName?: string;
  Year?: string | number;
  Dimensions?: string;
  Width?: number;
  Height?: number;
  
  // فیلد کمکی فرانت‌اند
  isAd?: boolean;
}

export const getPreDraftNoticeOData = async (): Promise<NoticeHeaderDto | null> => {
  // اکسپند کردن Category و NoticeDetails به همراه مرتب‌سازی بر اساس Order
  const query = `?$filter=NoticeState eq 'PreDraft'&$top=1&$expand=Category($select=LocalizedName),NoticeDetails($orderby=Order asc)`;
  
  const response = await apiClient.get<{ value: NoticeHeaderDto[] }>(
    `/Notice/odata/NoticeHeaderOData${query}`
  );
  
  return response.data.value.length > 0 ? response.data.value[0] : null;
};


export const getNoticesOData = async (
  skip: number = 0,
  top: number = 10
): Promise<NoticeHeaderDto[]> => {
  // استفاده از OData Query برای پیجینیشن و اکسپند کردن Category
  const query = `?$expand=Category($select=LocalizedName)&$skip=${skip}&$top=${top}&$orderby=CreatedDate desc`;
  const response = await apiClient.get<{ value: NoticeHeaderDto[] }>(
    `/Notice/odata/NoticeHeaderOData${query}`
  );
  return response.data.value;
};

 